<template>
    <div class="container" v-loading="loading">
        <h3 class="title">
            {{user_key}}&nbsp;连接记录
            <el-button type="primary" @click="back" size="mini">返回</el-button>
        </h3>
        <el-table
                :data="recordList"
                :height="tableHeight"
                style="width: 100%">
            <el-table-column
                    header-align="center"
                    align="center"
                    prop="id"
                    label="ID"
                    width="100">
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    prop="user_key"
                    label="API">
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    prop="ip"
                    width="150"
                    label="IP">
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    prop="port"
                    label="PORT"
            >
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    label="连接时间"
            >
                <template slot-scope="scope">
                    {{scope.row.addts | tsToDateTime}}
                </template>
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    label="断开时间"
            >
                <template slot-scope="scope">
                    {{scope.row.delts | tsToDateTime}}
                </template>
            </el-table-column>
            <el-table-column
                    header-align="center"
                    align="center"
                    label="持续时间(s)"
            >
                <template slot-scope="scope">
                    {{(scope.row.delts - scope.row.addts)}}
                </template>
            </el-table-column>
        </el-table>
        <div class="foot-page">
            <el-pagination
                    style="display: inline-block"
                    layout="prev, pager, next"
                    :page-size="page_size"
                    :current-page.sync="current_page"
                    @current-change="handlePageChange"
                    :total="total">
            </el-pagination>
        </div>

    </div>
</template>
<script>
  import dateRangePicker from "./dateRangePicker";
  import {apiGetConnectionRecord} from "@/api";
  import moment from "moment";

  export default {
    name: 'connectionRecords',
    components: {
      dateRangePicker
    },
    props: {
      user_key: {
        type: String,
        default: ""
      }
    },
    data() {
      return {
        // currentKey: this.key,
        loading: false,
        tableHeight: 0,
        current_page: 1,
        page_size: 200,
        recordList: [],
        total: 0
      }
    },
    created() {
      this.computedTableHeight()
    },
    mounted() {
      this.getConnectionRecords()
    },
    methods: {
      handlePageChange() {
        this.getConnectionRecords()
      },
      computedTableHeight() {
        this.tableHeight = document.body.offsetHeight - 100 - 80
      },
      back() {
        this.$router.go(-1)
      },
      async getConnectionRecords() {
        this.loading = true
        try {
          const res = await apiGetConnectionRecord(
            {
              user_key: this.user_key,
              page_num: this.current_page,
              per_page: this.page_size
            }
          );
          this.recordList = res.page_list
          this.total = res.total
          this.loading = false
        } catch (e) {
          console.log(e);
          this.$message.error('查询失败')
          this.loading = false
        }
      }
    },
    filters: {},
    computed: {},
    watch: {}
  }
</script>
<style lang="scss" scoped>
    .container {
        .foot-page {
            text-align: center;
        }
    }
</style>
